/**
 * Country-aware ID label + sensible country option list.
 * Mirrors /app/backend/services/profile_helpers.py.
 */
export const ID_LABELS = {
  PL: 'PESEL',
  US: 'SSN',
  CA: 'SIN',
  GB: 'NI Number',
  DE: 'Steuer-ID',
  IT: 'Codice Fiscale',
  ES: 'DNI/NIE',
  FR: 'INSEE',
};

export function idLabelFor(countryCode) {
  if (!countryCode) return 'National ID';
  return ID_LABELS[String(countryCode).toUpperCase()] || 'National ID';
}

// Same list as the clinic-onboarding form so admins + patients stay consistent.
export const COUNTRY_OPTIONS = [
  { code: 'PL', name: 'Poland' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'ES', name: 'Spain' },
  { code: 'IT', name: 'Italy' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'IE', name: 'Ireland' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'BE', name: 'Belgium' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'AT', name: 'Austria' },
  { code: 'PT', name: 'Portugal' },
  { code: 'SE', name: 'Sweden' },
  { code: 'NO', name: 'Norway' },
  { code: 'DK', name: 'Denmark' },
  { code: 'FI', name: 'Finland' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'HU', name: 'Hungary' },
  { code: 'RO', name: 'Romania' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  { code: 'MX', name: 'Mexico' },
  { code: 'BR', name: 'Brazil' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AU', name: 'Australia' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'JP', name: 'Japan' },
  { code: 'KR', name: 'South Korea' },
  { code: 'SG', name: 'Singapore' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'IL', name: 'Israel' },
  { code: 'IN', name: 'India' },
  { code: 'KN', name: 'Saint Kitts & Nevis' },
];

// Human-readable list of the field keys returned by /api/patients/me/completeness.
export const REQUIRED_FIELD_LABELS = {
  full_name: 'Full name',
  first_name: 'First name',
  last_name: 'Last name',
  date_of_birth: 'Date of birth',
  sex: 'Sex',
  phone: 'Phone',
  address: 'Street address',
  city: 'City',
  postal_code: 'Postal code',
  country: 'Country',
  id_number: 'ID number',
};
